import React from 'react';
import Cookie from 'js-cookie';

import Modal from 'common/components/modals/Modal';
import Button from 'common/components/Button';
import { editMembershipPods as managePath } from 'apps/account/paths';
import { TranslatedMessage } from 'common/components/Intl';
// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as paths from 'apps/cart/paths';

export const COOKIE_KEY_MEMBERSHIP_CONFLICT_TYPE = 'membershipConflictType';

export default class MembershipConflictModal extends React.Component {
  state = {
    isClosed: false,
    shouldRedirectToManageAfterSave: false,
  };

  handleManageSubscription = () => {
    this.props.wipeCart();
    this.setState({ shouldRedirectToManageAfterSave: true });
  };

  handleOneOffPurchase = () => {
    this.clearCookieAndRedirect(paths.checkout());
  };

  clearCookieAndRedirect = url => {
    Cookie.remove(COOKIE_KEY_MEMBERSHIP_CONFLICT_TYPE);
    document.location.assign(url);
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.isSaving === false &&
      this.state.shouldRedirectToManageAfterSave
    ) {
      this.setState({ shouldRedirectToManageAfterSave: false });
      this.clearCookieAndRedirect(managePath());
    }
  }

  get conflictType() {
    return Cookie.get(COOKIE_KEY_MEMBERSHIP_CONFLICT_TYPE);
  }

  get isOpen() {
    return !!this.conflictType;
  }

  render() {
    return (
      <Modal
        className="MembershipConflictModal"
        bodyClassName="MembershipConflictModal__body"
        processing={this.state.shouldRedirectToManageAfterSave}
        isOpen={this.isOpen}
        closable={false}
      >
        <div className="natural-heading--small">
          <TranslatedMessage
            id={'cart.membership_conflict_modal.existing_subscription'}
          />
        </div>
        <div className="text">
          <TranslatedMessage id={'cart.membership_conflict_modal.options'} />:
        </div>
        <Button
          onClick={this.handleManageSubscription}
          className="MembershipConflictModal__button MembershipConflictModal__button--manage-subscription"
        >
          <TranslatedMessage
            id={'cart.membership_conflict_modal.button_current'}
          />
        </Button>
        <Button
          onClick={this.handleOneOffPurchase}
          className="MembershipConflictModal__button MembershipConflictModal__button--one-off button--outline"
        >
          <TranslatedMessage
            id={'cart.membership_conflict_modal.one_time_purchase'}
          />
        </Button>
      </Modal>
    );
  }
}
